var components
try {
  components = {
    uLoadingIcon: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-loading-icon/u-loading-icon" */ "uview-ui/components/u-loading-icon/u-loading-icon.vue"
      )
    },
    uSwiperIndicator: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-swiper-indicator/u-swiper-indicator" */ "uview-ui/components/u-swiper-indicator/u-swiper-indicator.vue"
      )
    },
  }
} catch (e) {
  if (
    e.message.indexOf("Cannot find module") !== -1 &&
    e.message.indexOf(".vue") !== -1
  ) {
    console.error(e.message)
    console.error("1. 排查组件名称拼写是否正确")
    console.error(
      "2. 排查组件是否符合 easycom 规范，文档：https://uniapp.dcloud.net.cn/collocation/pages?id=easycom"
    )
    console.error(
      "3. 若组件不符合 easycom 规范，需手动引入，并在 components 中注册该组件"
    )
  } else {
    throw e
  }
}
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var g0 = _vm.$u.addUnit(_vm.height)
  var g1 = _vm.$u.addUnit(_vm.radius)
  var g2 = !_vm.loading ? _vm.$u.addUnit(_vm.height) : null
  var g3 = !_vm.loading ? _vm.$u.addUnit(_vm.previousMargin) : null
  var g4 = !_vm.loading ? _vm.$u.addUnit(_vm.nextMargin) : null
  var l0 = !_vm.loading
    ? _vm.__map(_vm.list, function (item, index) {
        var $orig = _vm.__get_orig(item)
        var s0 = _vm.__get_style([_vm.itemStyle(index)])
        var m0 = _vm.getItemType(item)
        var g5 = m0 === "image" ? _vm.$u.addUnit(_vm.height) : null
        var g6 = m0 === "image" ? _vm.$u.addUnit(_vm.radius) : null
        var m1 = m0 === "image" ? _vm.getSource(item) : null
        var m2 = _vm.getItemType(item)
        var g7 = m2 === "video" ? _vm.$u.addUnit(_vm.height) : null
        var m3 = m2 === "video" ? _vm.getSource(item) : null
        var m4 = m2 === "video" ? _vm.getPoster(item) : null
        var g8 =
          m2 === "video"
            ? _vm.showTitle && _vm.$u.test.object(item) && item.title
            : null
        var g9 =
          _vm.showTitle &&
          _vm.$u.test.object(item) &&
          item.title &&
          _vm.$u.test.image(_vm.getSource(item))
        return {
          $orig: $orig,
          s0: s0,
          m0: m0,
          g5: g5,
          g6: g6,
          m1: m1,
          m2: m2,
          g7: g7,
          m3: m3,
          m4: m4,
          g8: g8,
          g9: g9,
        }
      })
    : null
  var s1 = _vm.__get_style([_vm.$u.addStyle(_vm.indicatorStyle)])
  var g10 =
    !_vm.loading && _vm.indicator && !_vm.showTitle ? _vm.list.length : null
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        g0: g0,
        g1: g1,
        g2: g2,
        g3: g3,
        g4: g4,
        l0: l0,
        s1: s1,
        g10: g10,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }